<div class="has-border cm-product-ratecap-section">
  <div class="cm-product-rates-title-group">
    <div class="cm-block">
      <h1 class="cm-sub-heading cm-product-rates-heading" role="heading" aria-level="2" tabindex="0">Rate caps</h1>
    </div>
  </div>
  <!-- Skeleton loader while loading -->
  <ng-container *ngIf="isLoading; else ratecapInfosTemplate">
    <app-skeleton-line> </app-skeleton-line>
    <app-skeleton-line width="80%"></app-skeleton-line>
    <app-skeleton-line width="60%"></app-skeleton-line>
    <app-skeleton-line width="90%"></app-skeleton-line>
  </ng-container>

  <ng-template #ratecapInfosTemplate>
    <div class="cm-link">
      <div class="cm-product-rates-list">
        <a
          class="cm-product-link"
          href="{{ ratecapInfo.rateCapUrl }}"
          target="{{ ratecapInfo.target }}"
          *ngFor="let ratecapInfo of ratecapInfos"
          [attr.aria-label]="'Learn more about ' + ratecapInfo.rateCapName"
        >
          <div class="content">
            <div class="cm-product-rates-item">
              {{ ratecapInfo.rateCapName }}
            </div>
          </div>
        </a>
        <div class="ratecap-action">
          <a
            title="View More"
            [routerLink]="['/advisor/latest-rates']"
            href="javascript:void(0)"
            aria-label="Learn More About Rate Caps"
            role="button"
          >
            View more
          </a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
